import { NodeModel } from "../_model/NodeModel";
import { DecorationArea } from "./decorationArea"
import { Types } from "../../utils/nodeTypes"
import imageOfTheAreas from "../../utils/imagesOfTheAreas";

class Area extends NodeModel {
  constructor(areaName) {
    super("Area");
    
    this.type = new Types().Area;
    this.x = 0;
    this.y = 0;
    this.yText = () => this.y + (this.height / 2) + 5;
    this.xText = () => this.x + this.width / 2;
    this.height = 100;
    this.width = 160;
    this.connectionPack = new Array();
    this.wasSet = false
    this.areaInfo = imageOfTheAreas[areaName];

    this.decorate = async function(callback, callback2) {
      this.decorator = new DecorationArea();
      await this.decorator.init(this, callback, callback2)
    }

    this.update = (nodeEdited) => {
      this.areaInfo = JSON.parse(JSON.stringify(nodeEdited.areaInfo));
      this.decorator.updateImage();

      this.stroke = nodeEdited.stroke
      this.expressionVisible = nodeEdited.expressionVisible;
      this.wasSet = true;

      this.decorator.setAdjustArea()
    }

    this.clone = () => {
      let cloned = new Area(areaName)
      cloned.id = this.id
      cloned.idName = this.idName
      cloned.type = this.type
      cloned.height = this.height;
      cloned.width = this.width;
      cloned.x = this.x
      cloned.y = this.y
      cloned.readOnly = this.readOnly
      cloned.expressionVisible = this.expressionVisible

      cloned.wasSet = this.wasSet
      cloned.stroke = this.stroke

      cloned.areaInfo = JSON.parse(JSON.stringify(this.areaInfo));
      cloned.connectionPack = this.connectionPack.map(c => ({ conn: {...c.conn, decorator: null }, dot: c.dot }))

      return cloned
    }

    this.copyFrom = (node) => {
      this.simpleCopyFrom(node)
      this.wasSet = node.wasSet
      this.stroke = node.stroke
      this.connectionPack = node.connectionPack
      this.areaInfo = JSON.parse(JSON.stringify(node.areaInfo));
    }

    this.removeConnection = (connectionId) => {
      this.connectionPack = this.connectionPack.filter(connection => connection.conn.id != connectionId)
    }
  }
}


export { Area };